import API from "../BaseURL";

const configJson = {
    headers: {
      "content-type": "application/json",
    },
  };


export async function getAllLeafAnalysis() {
    const res = API.get(`/leaf_analysis/`, configJson);
    return res;
}


export async function getLeafAnalysisInfo(leafAnalysis_id) {
    const res = API.get(`/leaf_analysis/${leafAnalysis_id}`, configJson);
    return res;
}


export async function createLeafAnalysis(data) {
    const res = API.post(`/leaf_analysis/`, data, configJson);
    return res;
}


export async function updateLeafAnalysis(leafAnalysis_id, data) {
    const res = API.put(`/leaf_analysis/${leafAnalysis_id}/`, data, configJson);
    return res;
}


export async function deleteLeafAnalysis(leafAnalysis_id) {
    const res = API.delete(`/leaf_analysis/${leafAnalysis_id}/`, configJson);
    return res;
}


export async function getLeafAnalysisByExploitation(exploitation_id) {
    const res = API.get(`/leaf_analysis/exploitation/${exploitation_id}`, configJson);
    return res;
}


export async function getLastLeafAnalysis(exploitation_id) {
    const res = API.get(`/leaf_analysis/last/exploitation/${exploitation_id}`, configJson);
    return (await res).data;
}